import { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppConfig } from '@ltvco/refresh-lib/ctx';
import RepairEstimateIllustration from 'images/repair-estimate/repair-estimate.svg';
import { ReportSectionCTACard } from 'components/shared/ReportSectionCTACard';

export const RepairEstimateCTA = () => {
  const navigate = useNavigate();
  const { trackEventGA4 } = useContext(AppConfig);

  const handleEstimateRepairCostClick = useCallback(() => {
    trackEventGA4({
      event_name: 'cta_click',
      type: 'view repair estimator',
    });
    navigate('/bumper-chat/chat/repair-cost-estimator');
  }, [navigate, trackEventGA4]);

  return (
    <ReportSectionCTACard
      id="repair-estimate-cta"
      headline="Don’t Overpay for Repairs"
      bodyText="See estimated repair costs, difficulty, and urgency for your vehicle."
      buttonText="Estimate Repair Cost"
      onButtonClick={handleEstimateRepairCostClick}
      illustration={{
        src: RepairEstimateIllustration,
        alt: 'Repair estimate preview showing a sample analysis result',
      }}
      dataTestId="repair-estimate-cta"
    />
  );
};
